import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-09ecbfb0")

_pushScopeId("data-v-09ecbfb0")
const _hoisted_1 = /*#__PURE__*/_createTextVNode("自动化脚本")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("场景脚本")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("新增")
const _hoisted_4 = { class: "script" }
const _hoisted_5 = {
  key: 0,
  class: "table-div"
}
const _hoisted_6 = { key: 1 }
const _hoisted_7 = {
  key: 0,
  class: "table-div"
}
const _hoisted_8 = { key: 1 }
const _hoisted_9 = {
  key: 0,
  class: "table-div"
}
const _hoisted_10 = { key: 1 }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("脚本下载")
const _hoisted_12 = { class: "dialogTitle" }
const _hoisted_13 = /*#__PURE__*/_createVNode("span", null, "新增场景", -1)
const _hoisted_14 = { class: "dialog-footer" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode("取 消")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("确 认")
const _hoisted_17 = { class: "dialogTitle" }
const _hoisted_18 = /*#__PURE__*/_createVNode("span", null, "新增场景脚本", -1)
const _hoisted_19 = /*#__PURE__*/_createTextVNode("+")
const _hoisted_20 = /*#__PURE__*/_createVNode("i", { class: "el-icon-upload" }, null, -1)
const _hoisted_21 = /*#__PURE__*/_createVNode("em", null, "点击上传", -1)
const _hoisted_22 = { class: "dialog-footer" }
const _hoisted_23 = /*#__PURE__*/_createTextVNode("取 消")
const _hoisted_24 = /*#__PURE__*/_createTextVNode("确 认")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_breadcrumb = _resolveComponent("el-breadcrumb")
  const _component_el_divider = _resolveComponent("el-divider")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_checkbox = _resolveComponent("el-checkbox")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")
  const _component_el_space = _resolveComponent("el-space")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_card = _resolveComponent("el-card")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_dialog = _resolveComponent("el-dialog")
  const _component_el_upload = _resolveComponent("el-upload")
  const _component_el_pagination = _resolveComponent("el-pagination")
  const _component_el_footer = _resolveComponent("el-footer")
  const _component_el_main = _resolveComponent("el-main")
  const _component_el_container = _resolveComponent("el-container")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock(_component_el_container, null, {
    default: _withId(() => [
      _createVNode(_component_el_container, null, {
        default: _withId(() => [
          _createVNode(_component_el_main, null, {
            default: _withId(() => [
              _createVNode(_component_el_breadcrumb, {
                "separator-class": "el-icon-arrow-right",
                class: "PosTitle"
              }, {
                default: _withId(() => [
                  _createVNode(_component_el_breadcrumb_item, null, {
                    default: _withId(() => [
                      _hoisted_1
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_breadcrumb_item, null, {
                    default: _withId(() => [
                      _hoisted_2
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_button, {
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleAddScriptV2())),
                    disabled: _ctx.get_is_super,
                    type: "primary",
                    size: "small",
                    class: "btnStyle"
                  }, {
                    default: _withId(() => [
                      _hoisted_3
                    ]),
                    _: 1
                  }, 8, ["disabled"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_divider),
              _withDirectives(_createVNode("div", _hoisted_4, [
                _createVNode(_component_el_card, { class: "spacName tableMinH" }, {
                  default: _withId(() => [
                    _createVNode(_component_el_table, {
                      size: "small",
                      data: 
                _ctx.getSimpleScripts.filter(
                  (data) =>
                    !_ctx.search ||
                    data.script_name
                      ?.toLowerCase()
                      .includes(_ctx.search.toLowerCase())
                )
              ,
                      "header-cell-class-name": "tabelHeader",
                      style: {"width":"100%"}
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_el_table_column, {
                          prop: "script_name",
                          label: "脚本名"
                        }, {
                          default: _withId((scope) => [
                            (scope.row.isEdit)
                              ? (_openBlock(), _createBlock("div", _hoisted_5, [
                                  _createVNode("input", {
                                    type: "text",
                                    class: "table-input",
                                    id: 'script_name' + scope.row.script_id,
                                    value: scope.row.script_name
                                  }, null, 8, ["id", "value"])
                                ]))
                              : (_openBlock(), _createBlock("span", _hoisted_6, _toDisplayString(scope.row.script_name), 1))
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          align: "center",
                          prop: "script_id",
                          label: "脚本id"
                        }, {
                          default: _withId((scope) => [
                            _createVNode("span", null, _toDisplayString(scope.row.script_id), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          prop: "scene_chinese",
                          label: "场景名"
                        }, {
                          default: _withId((scope) => [
                            (scope.row.isEdit)
                              ? (_openBlock(), _createBlock("div", _hoisted_7, [
                                  _createVNode(_component_el_select, {
                                    modelValue: scope.row.scene_chinese,
                                    "onUpdate:modelValue": ($event: any) => (scope.row.scene_chinese = $event),
                                    id: 'scene_chinese' + scope.row.script_id,
                                    filterable: "",
                                    "allow-create": "",
                                    size: "mini",
                                    onChange: ($event: any) => (_ctx.changeID(scope.row))
                                  }, {
                                    default: _withId(() => [
                                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.getProjectScenes, (item) => {
                                        return (_openBlock(), _createBlock(_component_el_option, {
                                          key: item.id,
                                          label: item.chinese,
                                          value: item.id
                                        }, null, 8, ["label", "value"]))
                                      }), 128))
                                    ]),
                                    _: 2
                                  }, 1032, ["modelValue", "onUpdate:modelValue", "id", "onChange"])
                                ]))
                              : (_openBlock(), _createBlock("span", _hoisted_8, _toDisplayString(scope.row.scene_chinese), 1))
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          align: "center",
                          prop: "scene_id",
                          label: "场景id"
                        }, {
                          default: _withId((scope) => [
                            _createVNode("span", null, _toDisplayString(scope.row.scene_id ? scope.row.scene_id : "--"), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          label: "自定义id",
                          prop: "original_scene_id",
                          align: "center"
                        }, {
                          default: _withId((scope) => [
                            (scope.row.isEdit)
                              ? (_openBlock(), _createBlock("div", _hoisted_9, [
                                  _createVNode("input", {
                                    type: "text",
                                    class: "table-input",
                                    id: 'original_scene_id' + scope.row.script_id,
                                    value: scope.row.original_scene_id
                                  }, null, 8, ["id", "value"])
                                ]))
                              : (_openBlock(), _createBlock("span", _hoisted_10, _toDisplayString(scope.row.original_scene_id), 1))
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          prop: "old_map",
                          label: "是否老地图",
                          align: "center"
                        }, {
                          default: _withId((scope) => [
                            _createVNode(_component_el_checkbox, {
                              modelValue: scope.row.old_map,
                              "onUpdate:modelValue": ($event: any) => (scope.row.old_map = $event),
                              onChange: ($event: any) => (_ctx.handleDeleteScript2(scope.row))
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          prop: "old_version",
                          label: "性能对比版本",
                          align: "center"
                        }, {
                          default: _withId((scope) => [
                            _createVNode(_component_el_select, {
                              disabled: scope.row.old_map ? false : true,
                              modelValue: scope.row.old_version,
                              "onUpdate:modelValue": ($event: any) => (scope.row.old_version = $event),
                              size: "mini",
                              placeholder: "请选择",
                              onChange: ($event: any) => (_ctx.handleDeleteScript2(scope.row))
                            }, {
                              default: _withId(() => [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.game_version_options, (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: item.value,
                                    label: item.label,
                                    value: item.value
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 2
                            }, 1032, ["disabled", "modelValue", "onUpdate:modelValue", "onChange"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          width: "250",
                          align: "right"
                        }, {
                          header: _withId(() => [
                            _createVNode(_component_el_input, {
                              modelValue: _ctx.search1,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.search1 = $event)),
                              size: "mini",
                              placeholder: "输入关键字搜索",
                              onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onSearch()))
                            }, null, 8, ["modelValue"])
                          ]),
                          default: _withId((scope) => [
                            _createVNode(_component_el_space, { wrap: "" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_button, {
                                  onClick: ($event: any) => (_ctx.downloadFile(scope.row)),
                                  type: "primary",
                                  size: "mini"
                                }, {
                                  default: _withId(() => [
                                    _hoisted_11
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"]),
                                _createVNode(_component_el_button, {
                                  size: "mini",
                                  type: scope.row.editButton,
                                  onClick: ($event: any) => (_ctx.handleEdit(scope.row, _ctx.scriptForm)),
                                  disabled: _ctx.get_is_super
                                }, {
                                  default: _withId(() => [
                                    _createTextVNode(_toDisplayString(scope.row.handleEditText), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["type", "onClick", "disabled"]),
                                _createVNode(_component_el_popconfirm, {
                                  onConfirm: ($event: any) => (_ctx.handleDeleteScript(scope.row, _ctx.scriptForm)),
                                  title: scope.row.handleConfirmText
                                }, {
                                  reference: _withId(() => [
                                    _createVNode(_component_el_button, {
                                      size: "mini",
                                      disabled: _ctx.get_is_super,
                                      type: scope.row.isDanger
                                    }, {
                                      default: _withId(() => [
                                        _createTextVNode(_toDisplayString(scope.row.handleDeleteText), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["disabled", "type"])
                                  ]),
                                  _: 2
                                }, 1032, ["onConfirm", "title"])
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["data"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_dialog, {
                  width: "615px",
                  onClose: _ctx.closeAddScript,
                  modelValue: _ctx.addScript,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.addScript = $event))
                }, {
                  title: _withId(() => [
                    _createVNode("div", _hoisted_12, [
                      _hoisted_13,
                      _createVNode(_component_el_divider)
                    ])
                  ]),
                  footer: _withId(() => [
                    _createVNode("span", _hoisted_14, [
                      _createVNode(_component_el_button, {
                        size: "small",
                        onClick: _ctx.closeAddScript,
                        type: "info"
                      }, {
                        default: _withId(() => [
                          _hoisted_15
                        ]),
                        _: 1
                      }, 8, ["onClick"]),
                      _createVNode(_component_el_button, {
                        size: "small",
                        type: "primary",
                        onClick: _ctx.addAddScript
                      }, {
                        default: _withId(() => [
                          _hoisted_16
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ])
                  ]),
                  default: _withId(() => [
                    _createVNode(_component_el_form, {
                      inline: true,
                      "label-position": "top",
                      style: {"justify-content":"space-around"},
                      size: "small"
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_el_form_item, {
                          label: "场景名称",
                          size: "small",
                          prop: "original_scene_id",
                          style: {"width":"40%"}
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_input, {
                              placeholder: "请输入场景名称",
                              modelValue: _ctx.addScriptForm.chinese,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.addScriptForm.chinese = $event)),
                              autocomplete: "off"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, {
                          label: "游戏场景id",
                          size: "small",
                          prop: "chinese",
                          style: {"width":"40%","margin-left":"30px"}
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_input, {
                              placeholder: "请输入游戏场景id",
                              modelValue: _ctx.addScriptForm.original_scene_id,
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.addScriptForm.original_scene_id = $event)),
                              autocomplete: "off"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["onClose", "modelValue"]),
                _createVNode(_component_el_dialog, {
                  width: "615px",
                  onClose: _cache[12] || (_cache[12] = ($event: any) => (_ctx.resetAddForm('ruleaddForm'))),
                  modelValue: _ctx.dialogAddFormVisible,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.dialogAddFormVisible = $event))
                }, {
                  title: _withId(() => [
                    _createVNode("div", _hoisted_17, [
                      _hoisted_18,
                      _createVNode(_component_el_divider)
                    ])
                  ]),
                  footer: _withId(() => [
                    _createVNode("span", _hoisted_22, [
                      _createVNode(_component_el_button, {
                        size: "small",
                        onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.resetAddForm('ruleaddForm'))),
                        type: "info"
                      }, {
                        default: _withId(() => [
                          _hoisted_23
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_button, {
                        size: "small",
                        type: "primary",
                        onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.submitAddForm()))
                      }, {
                        default: _withId(() => [
                          _hoisted_24
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  default: _withId(() => [
                    _createVNode(_component_el_form, {
                      model: _ctx.addForm,
                      inline: true,
                      "label-position": "top",
                      ref: "ruleaddForm",
                      style: {"justify-content":"space-around"},
                      size: "small"
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_el_form_item, {
                          label: "场景 (脚本过滤)",
                          prop: "script_scene",
                          style: {"width":"160px"}
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_select, {
                              modelValue: _ctx.filterScript,
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.filterScript = $event)),
                              filterable: "",
                              clearable: "",
                              placeholder: "请选择场景",
                              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.activation()))
                            }, {
                              default: _withId(() => [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.getProjectScenes, (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: item.id,
                                    label: item.chinese,
                                    value: item.id
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue"]),
                            _createVNode(_component_el_button, {
                              onClick: _ctx.openAddScript,
                              style: {"color":"#c0c4cc"}
                            }, {
                              default: _withId(() => [
                                _hoisted_19
                              ]),
                              _: 1
                            }, 8, ["onClick"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, {
                          label: "脚本名称",
                          prop: "chinese",
                          style: {"width":"160px"}
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_input, {
                              modelValue: _ctx.addForm.chinese,
                              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.addForm.chinese = $event)),
                              placeholder: "请输入脚本名称",
                              autocomplete: "off"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, {
                          label: "脚本",
                          prop: "script_id",
                          align: "center"
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_upload, {
                              class: "upload-demo uploadBox",
                              action: "http://127.0.0.1:8080/api/v1/task/scene_script_create/",
                              limit: 1,
                              "http-request": _ctx.ploadImage,
                              "on-remove": _ctx.ploadImage,
                              style: {"color":"#c0c4cc","border":"1px solid #dcdfe6","border-radius":"4px","height":"32px","width":"160px","position":"relative"},
                              ref: 'upload'
                            }, {
                              default: _withId(() => [
                                _hoisted_20,
                                _hoisted_21
                              ]),
                              _: 1
                            }, 8, ["http-request", "on-remove"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["model"])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ], 512), [
                [_directive_loading, _ctx.loading]
              ]),
              _createVNode(_component_el_footer, { class: "footerStyle" }, {
                default: _withId(() => [
                  _createVNode(_component_el_pagination, {
                    "current-page": _ctx.currentPage1,
                    "onUpdate:current-page": _cache[14] || (_cache[14] = ($event: any) => (_ctx.currentPage1 = $event)),
                    "page-size": _ctx.record,
                    layout: "total, prev, pager, next, jumper",
                    total: _ctx.totalNum,
                    onCurrentChange: _cache[15] || (_cache[15] = ($event: any) => (_ctx.onPaging(_ctx.record, $event))),
                    style: {"margin-top":"20px","justify-content":"flex-end"}
                  }, null, 8, ["current-page", "page-size", "total"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})